/**
 * Si `new maplibregl.Map` tira a mitad de camino, ya agregó su canvas y clases al
 * contenedor. Sin instancia no hay `remove()`: limpiamos a mano para que no quede
 * un rectángulo negro tapando el aviso.
 *
 * @param {HTMLElement|null|undefined} container
 */
export function cleanupFailedMapContainer(container) {
  if (!container || typeof container !== 'object') return;
  try {
    while (container.firstChild) container.removeChild(container.firstChild);
    if (container.classList) {
      Array.from(container.classList)
        .filter((name) => name.startsWith('maplibregl-'))
        .forEach((name) => container.classList.remove(name));
    }
  } catch (_) { /* noop */ }
}
